import { Directive, ElementRef, HostListener, OnDestroy } from "@angular/core"
import { MdSnackBar } from "@angular/material"

@Directive({
  selector: "[appCopy]"
})
export class CopyDirective implements OnDestroy {
  private clipboard: any

  constructor(
    element: ElementRef,
    public snackBar: MdSnackBar
  ) {
    this.clipboard = new Clipboard(element.nativeElement)
    this.clipboard.on("success", (event) => {
      this.snackBar.open("Copied Link", null, {
        duration: 1000
      })
    })
  }

  // Prevent the text in input to be selected on mobile
  @HostListener("click", ["$event"])
  onClick(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
  }

  ngOnDestroy() {
    this.clipboard.destroy()
  }
}



// WEBPACK FOOTER //
// /home/runner/work/onelocal/onelocal/src/my-referral/src/app/copy.directive.ts